<p-dialog
  position="center"
  styleClass="possible-duplicate-dialog"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [autoZIndex]="true"
  [style]="{ width: '820px', maxWidth: '95vw' }"
  [visible]="visible"
  (visibleChange)="!$event && close()"
  [transitionOptions]="'2ms'">
  <ng-template pTemplate="header">
    <div class="dialog-header">
      <i class="pi pi-users header-icon"></i>
      <h5 class="p-dialog-title">Possible Duplicate Contact</h5>
    </div>
  </ng-template>

  <div class="duplicate-body" *ngIf="existing">
    <p class="intro-text">
      We found an existing contact with the <strong>{{ matchLabel | lowercase }}</strong
      >.
    </p>

    <div class="compare-grid">
      <div class="contact-card">
        <div class="card-top">
          <span class="card-label">This lead</span>
          <span class="pill pill-green">New</span>
        </div>
        <div class="identity">
          <span class="avatar">{{ newInitials }}</span>
          <div class="identity-text">
            <p class="identity-name">{{ newFirstName }} {{ newLastName }}</p>
            <p class="identity-type">New lead</p>
          </div>
          <span class="pill pill-outline identity-pill" *ngIf="isNewName">New name</span>
        </div>
        <div class="detail-row">
          <i class="pi pi-envelope"></i>
          <span class="detail-value">{{ newContact?.email || '–' }}</span>
          <span class="pill pill-green" *ngIf="isEmailMatch">Same email</span>
          <span class="pill pill-outline" *ngIf="isNewEmail">New email</span>
        </div>
        <div class="detail-row">
          <i class="pi pi-phone"></i>
          <span class="detail-value">{{ (newContact?.mobile | mobileFormat) || '–' }}</span>
          <span class="pill pill-green" *ngIf="isMobileMatch">Same mobile</span>
          <span class="pill pill-outline" *ngIf="isNewMobile">New mobile</span>
        </div>
        <div class="label-field">
          <i class="pi pi-tag"></i>
          <ng-select
            class="label-field__select"
            [items]="labelOptions"
            [(ngModel)]="selectedLabel"
            [addTag]="addCustomLabel"
            addTagText="Add"
            [clearable]="true"
            [markFirst]="false"
            placeholder="Select Label (optional)"
            appendTo="body"></ng-select>
        </div>
      </div>

      <div class="compare-link">
        <span class="link-line"></span>
        <span class="link-badge"><i class="pi pi-link"></i></span>
        <span class="link-line"></span>
      </div>

      <div class="contact-card">
        <div class="card-top">
          <span class="card-label">Existing contact</span>
          <span class="pill pill-gray">Already in Remmi</span>
          <div class="pager" *ngIf="contacts.length > 1">
            <button type="button" class="pager-btn" [disabled]="activeIndex === 0" (click)="showPrevious()">
              <i class="pi pi-chevron-left"></i>
            </button>
            <span class="pager-count">{{ activeIndex + 1 }} / {{ contacts.length }}</span>
            <button type="button" class="pager-btn" [disabled]="activeIndex === contacts.length - 1" (click)="showNext()">
              <i class="pi pi-chevron-right"></i>
            </button>
          </div>
        </div>
        <div class="identity">
          <span class="avatar">{{ existingInitials }}</span>
          <div class="identity-text">
            <p class="identity-name">{{ existingFirstName }} {{ existingLastName }}</p>
            <p class="identity-type">{{ existing.user_type || existing.type || 'Contact' }}</p>
          </div>
        </div>
        <div class="detail-row">
          <i class="pi pi-envelope"></i>
          <span class="detail-value">{{ existing.email || '–' }}</span>
        </div>
        <div class="detail-row">
          <i class="pi pi-phone"></i>
          <span class="detail-value">{{ (existing.mobile_no | mobileFormat) || '–' }}</span>
        </div>
      </div>
    </div>

    <p class="choice-title">What do you want to do?</p>
    <div class="choice-grid">
      <label class="choice-tile" [class.active]="isSamePerson" for="duplicateSamePerson">
        <p-radioButton inputId="duplicateSamePerson" name="duplicateChoice" [value]="true" [(ngModel)]="isSamePerson"></p-radioButton>
        <i class="pi pi-link choice-icon"></i>
        <span class="choice-text">
          <span class="choice-heading">Link to existing contact</span>
          <span class="choice-hint"> Use the existing contact in Remmi and add this lead to their record. </span>
        </span>
      </label>
      <label class="choice-tile" [class.active]="!isSamePerson" for="duplicateCreateNew">
        <p-radioButton inputId="duplicateCreateNew" name="duplicateChoice" [value]="false" [(ngModel)]="isSamePerson"></p-radioButton>
        <i class="pi pi-user-plus choice-icon"></i>
        <span class="choice-text">
          <span class="choice-heading">Create a new contact</span>
          <span class="choice-hint">Keep this as a separate contact in Remmi.</span>
        </span>
      </label>
    </div>
  </div>

  <ng-template pTemplate="footer">
    <div class="dialog-footer">
      <button type="button" class="_cancel-btn" (click)="close()">Cancel</button>
      <button type="button" class="_primary-btn" (click)="confirm()">{{ confirmLabel }}</button>
    </div>
  </ng-template>
</p-dialog>
